<template>
  <div class="content">
    <Hero
        :image="getStrapiImageLocation(data?.image) || ''"
        image-provider="strapi"
        extra-content-classes="vcenter grid--two"
        :vertical-center="true"
        small
      >
      <template #left>
        <h2 class="heading--med text--white">{{ data?.preTitle }}<br/><b>{{ data?.title }}</b></h2>
      </template>
    </Hero>
    <div class="block block--gray block--yl mt-25" v-if="(data?.stories?.length || 0) > 0">
      <div class="maxw--inner">
        <h2 class="heading--med text--primary mb-2">{{ data?.stories[0].heading }}</h2>
        <div class="divider-thick divider--accent"></div>
        <div class="grid-text-img">
          <div class="text--m">
             <StrapiBlocksText :nodes="data?.stories[0].content || []"/>
          </div>
          <div>
            <div class="image--holder">
              <NuxtImg :src="getStrapiImageLocation(data?.stories[0].image) || ''" provider="strapi"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block block--top-gray block--noflow" v-if="(data?.stories?.length || 0) > 1">
      <div class="block block--white maxw--inner block--px-l">
        <div class="mb-1">
          <div class="text--m">
            <div class="image--holder floating-left" style="height: 25rem;">
              <NuxtImg :src="getStrapiImageLocation(data?.stories[0].image) || ''" :alt="data?.stories[1].heading" style="object-position: 0 top;"/>
            </div>
            <h2 class="heading--med text--primary mb-2">{{ data?.stories[1].heading }}</h2>
            <StrapiBlocksText :nodes="data?.stories[1].content || []"/>
          </div>
        </div>
      </div>
    </div>
    <div class="block maxw--inner text--center">
      <nuxt-link to="/" class="text--secondary">&lt; Terug naar overzicht</nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type StoryPage from '~/typings/strapi/pages/storyPage';

const { findOne } = useStrapi();
const route = useRoute();

const { data } = await useAsyncData(
  'storyPage',
  () => findOne<StoryPage>(`slugify/slugs/story-page/${route.params.slug}`, {
    populate: ['image', 'stories.image', 'seo', 'seo.metaImage']
  }),
  {
    transform: flattenObject
  }
);

if (!data.value) {
  throw createError({ statusCode: 404, message: 'Verhaal niet gevonden' });
}

useHead({
  titleTemplate: '%s | Van Eerd - Werken bij',
  title: `${data.value?.preTitle} ${data.value?.title}`
});

useSeoMeta({
  description: data.value?.seo?.metaDescription,
  ogTitle: data.value?.seo?.metaTitle,
  ogDescription: data.value?.seo?.metaDescription,
  ogImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  ogUrl: 'https://werkenbijvaneerd.nl/ervaringsverhalen/' + data.value?.slug,
  twitterTitle: data.value?.seo?.metaTitle,
  twitterDescription: data.value?.seo?.metaDescription,
  twitterImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  twitterCard: 'summary_large_image',
})
</script>
